import type { NavigateFunctionOptions } from '../types';
import { usePlatformFunctionality } from '../context/PlatformFunctionalityProvider';

function defaultNavigateFunction(path: string): void {
  location.href = path;
}

export function useNavigate(): (path: string, options?: NavigateFunctionOptions) => void {
  const { navigateFunction } = usePlatformFunctionality();

  return navigateFunction ?? defaultNavigateFunction;
}
